import React, { useState } from 'react';
import { formatCurrency } from '../gameData';
import AlertDialog from './AlertDialog';

function DebtDialog({ show, onConfirm, onClose, maxAmount, currentDebt }) {
  const [amount, setAmount] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const handleSubmit = () => {
    const repayAmount = parseInt(amount);
    if (repayAmount > 0 && repayAmount <= maxAmount) {
      onConfirm(repayAmount);
      setAmount('');
    } else {
      setAlertMessage("Invalid amount or insufficient funds.");
      setShowAlert(true);
    }
  };

  const handleRepayAll = () => {
    if (maxAmount >= currentDebt) {
      onConfirm(currentDebt);
      setAmount('');
    }
  };

  if (!show) return null;

  const canRepayAll = maxAmount >= currentDebt;

  return (
    <>
      <dialog open={show} className="debt-dialog">
        <h3>💰 Repay Debt 💰</h3>
        <p>Current Debt: {formatCurrency(currentDebt)}</p>
        <p>Available Money: {formatCurrency(maxAmount)}</p>
        
        <div className="debt-options">
          <button 
            onClick={handleRepayAll}
            disabled={!canRepayAll}
            className={canRepayAll ? 'primary-button' : 'disabled-button'}
          >
            Repay Full Balance ({formatCurrency(currentDebt)})
          </button>
          
          <div className="debt-custom">
            <p>Or enter custom amount:</p>
            <div className="debt-input">
              <input
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                min="1"
                max={maxAmount}
                placeholder="Enter amount to repay"
              />
            </div>
            <div className="dialog-buttons">
              <button onClick={handleSubmit}>Confirm</button>
              <button onClick={onClose}>Cancel</button>
            </div>
          </div>
        </div>
      </dialog>

      <AlertDialog
        show={showAlert}
        message={alertMessage}
        onClose={() => setShowAlert(false)}
      />
    </>
  );
}

export default DebtDialog; 